import type { Product, ProductAttributeGroupOfValue, ProductVariant } from "../Product.js";

/**
 * Identifier of a product variant + attribute combination, used as the Offer `sku` in
 * structured data, as `g:id` in the Google Merchant feed and as `item_id` in analytics
 * events — all three must stay equal for Google to match feed items with product pages
 * and with the products a visitor viewed. Google limits the identifier to 50 characters.
 */
export function getProductVariantCombinationSku(
	product: Pick<Product, "id">,
	variant: Pick<ProductVariant, "id">,
	attributes: readonly Pick<ProductAttributeGroupOfValue, "value">[],
): string {
	if (attributes.length === 0) {
		return `${product.id}::${variant.id}`;
	}
	// With the full product UUID (36 chars) the sku would exceed the 50 character limit
	// once attribute value ids are appended, so only its first segment is kept.
	const attributeValueIds = attributes
		.map(({ value }) => value.id)
		.sort()
		.join(":");
	return `${product.id.slice(0, 8)}::${variant.id}::${attributeValueIds}`;
}
